import { normalizeMoneyInput } from "./money";

/** Texto digitado ("1.500,50") → centavos inteiros; null se não for um valor válido. */
export function centsOf(raw: string): number | null {
  const n = normalizeMoneyInput(raw);
  if (n === null) return null;
  const neg = n.startsWith("-"), [i, f = ""] = n.replace("-", "").split(".");
  const v = Number(i) * 100 + Number((f + "00").slice(0, 2));
  return neg ? -v : v;
}
/** Centavos → texto pt-BR para campos ("1.500,50"). */
export const centsText = (c: number) => (c / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
/** Centavos → "R$ 1.500,50". */
export const brlCents = (c: number) => `R$ ${centsText(c)}`;
/** Reparte centavos em pontos-base (maior resto) — espelha o servidor, só para exibir a prévia das parcelas. */
export function splitBp(cents: number, bps: number[]): number[] {
  const floors = bps.map((b) => Math.floor((cents * b) / 10000));
  let left = cents - floors.reduce((s, x) => s + x, 0);
  const order = bps.map((b, i) => ({ i, r: (cents * b) % 10000 })).sort((a, b) => b.r - a.r || a.i - b.i);
  for (const o of order) { if (left <= 0) break; floors[o.i]! += 1; left -= 1; }
  return floors;
}
